import { createSelector } from 'reselect';

export const getAppState = state => state.appState;

export const getIsDivaSelected = createSelector(
  getAppState,
  appState => appState.divaSelected || false
);
